module.exports = __webpack_public_path__ + "assets/media/evening.0a6d16b1.mp3";